import { cn } from '../../utils'

type Props = React.ComponentProps<'textarea'>

/**
 * otherのテキスト入力フィールド
 */
export function ElementOtherTextField({ ref, className, ...props }: Props & { ref?: React.RefObject<HTMLTextAreaElement | null> }) {
  return (
    <div className="my-5 flex flex-col gap-2">
      <textarea
        className={cn(
          'h-[76px] w-full rounded-md border p-3 outline outline-1 outline-[#909190] focus:outline-[var(--theme-outline-color)] text-[var(--theme-title-color)]',
          className,
        )}
        ref={ref}
        {...props}
      />
    </div>
  )
}
